import styled from 'styled-components'

import { device } from '@util/breakpoints'
import { spacing } from '@util/spacing'

/**
 * Shared Styled Components for:
 * - Logged In Views (A and B version)
 * - SMS Form Container
 */

type SectionTextProps = { textAlign?: string }

export const SectionText = styled.span<SectionTextProps>`
  display: block;
  width: 100%;
  font-size: 1rem;
  margin-bottom: 1.26rem;
  line-height: 1.5;
  /* Original view aligns left, Alt view aligns center */
  text-align: ${(props) => props.textAlign || 'left'};

  @media ${device.desktop} {
    padding-right: 0;
  }
`

export const BottomContent = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 ${spacing.s40} 0;
  /* needed for IE11 respecting max-width for wrapping elem */
  width: 100%;

  @media ${device.tablet} {
    margin: 0 auto;
  }
`

// holds the content to overlap with the gradient background
export const ContentWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 45px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const TopContentHeading = styled.h1`
  margin-top: 0;
  font-family: Playfair Display, Times, serif;
  font-size: 2.25rem;
  line-height: ${spacing.s40};
  font-weight: 400;
  color: #fff;

  @media ${device.tablet} {
    font-size: 3em;
  }
`

export const AltTopContentHeading = styled(TopContentHeading)`
  margin-bottom: 36px;
`

export const HomeContainer = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`

export const AccentBlock = styled.div`
  border-top: 6px solid #8028ea;
  width: 35px;
  margin: 0.7rem 0 ${spacing.s24} 0;

  @media ${device.tablet} {
    width: 50px;
    margin: ${spacing.s64} 0 ${spacing.s24} 0;
  }
`

export const Picture = styled.picture`
  padding: 0 10px;

  @media ${device.mobileL} {
    padding: 0;
  }
`

export const Img = styled.img`
  display: block;
  width: 100%;

  @media ${device.mobileL} {
    max-width: 440px;
  }

  @media ${device.desktopM} {
    max-width: 500px;
  }
`

export const DesktopWrapper = styled.div`
  display: none;

  @media ${device.tablet} {
    display: block;
  }

  @media ${device.desktop} {
    display: block;
  }

  @media ${device.desktopM} {
    display: block;
  }
`

export const MobileWrapper = styled.div`
  @media ${device.tablet} {
    display: none;
  }

  @media ${device.desktop} {
    display: none;
  }

  @media ${device.desktopM} {
    display: none;
  }
`